<template>
<div class="page_toutiao page_shequ">
    <!-- 列表 -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="getData">
        <div class="list">
            <div class="item" v-for="(item,index) in dataList" :key="index">
                <div class="item_t">
                    <div class="item_t_l" @click="goDetail(item)">
						<van-image fit="cover" :src="item.userthumb ? ($publicData.withHttpStart(item.userthumb) ? item.userthumb : imageUrl+item.userthumb ) : $publicData.headLineTouxiang" class="tu" :show-error="true" :error-icon="$publicData.headLineTouxiang" :show-loading="false" />
                        <div class="text">
                            <div class="text_t">
                                <div class="title slh_s">{{ item.username }}</div>
                                <!-- <div class="tag">官方</div> -->
                            </div>
                            <div class="time">{{ item.created_at }}</div>
                        </div>
                    </div>
                </div>
                <div class="item_title" @click="goDetail(item)">{{item.type != 0 ? item.title : item.type == 0 && item.desc_hide==1 ? item.describe_hide : item.describe}}</div>
                <div class="lookall" v-if="item.desc_hide" @click="lookAllFun(item)">查看全文</div>
				<div class="lookall" v-if="item.desc_hide == 0" @click="hideFun(item)">收起全文</div>
                <!-- type为2时, 对应图文, 一张大图+标题  -->
                <div class="item_tu single" v-if="item.type == 2"  @click="goDetail(item)">
                    <van-image fit="cover" v-if="item.thumb" :src="imageUrl+item.thumb" class="tu" :show-error="false" :show-loading="false" />
                </div>
				<!-- type 为1时, 是视频 , 一张大图+标题 -->
				<div class="item_tu single" v-if="item.type == 1"  @click="goDetail(item)">
                    <van-image fit="cover" v-if="item.thumb" :src="imageUrl+item.thumb" class="tu mark" :show-error="false" :show-loading="false" />
                </div>
                <!-- type为0时, 对应图+文, 多张小图+描述-->
				<div class="item_tu more"  v-if="item.type == 0 && item.imagesArr">
					<div class="tu_wrap" v-for="(img,key) in item.images_hide ? item.imagesSlice : item.imagesArr" :key="key" @click="zhanshitupian(item,item.images_hide ? item.imagesSlice : item.imagesArr,key)">
						<van-image class="tu" fit="cover" :src="imageUrl+img" :show-error="false" :show-loading="false"/>
						<div class="mark" v-if="item.images_hide && key == 2">{{'+'+ (item.imagesArr.length -3)}}</div>
					</div>
                </div>
				<!-- 分隔线 -->
				<div class="line"></div>
                <!-- 评论 收藏 点赞 -->
                <div class="actions">
                    <div class="action comment" @click="goDetail(item)">
                        <div class="text">评论{{ '('+  item.num.comment_num + ')'}}</div>
                    </div>
                    <div :class="item.is_collect ? 'action collect collected' : 'action collect'" @click="clickCollect(item)">
                        <div class="text">收藏{{ '('+  item.num.collect_num + ')'}}</div>
                    </div>
                    <div :class="item.is_like ? 'action like liked' : 'action like'" @click="clickLike(item)">
                        <div class="text">点赞{{ '('+  item.num.like_num + ')'}}</div>
                    </div>
                </div>
            </div>
        </div>
    </van-list>
    <!-- 发布 -->
    <div class="post" @click="toPublish">
        <img :src="publicPath+'statics/images/icon_fabu.png'" alt="" class="">
    </div>
	<!-- 大图预览 -->
    <van-image-preview v-model="bigTuShow" :start-position="bigTuIndex" :images="bigTuImgArr" @change="bigTuChange"></van-image-preview>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: null,
            typeList: null, // 推荐分类
            push_type: null,
            pages: {
                page: 1,
                size: 10
            },
            loading: true,
			finished: false,
			dataList: [], // 列表
			bigTuShow: false,
			bigTuIndex: 0,
			bigTuImgArr: null,
			show_more_tu: false, // 加载更多图片，大于3张为真
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '我的圈子'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
				}
				this.getData()
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
			this.token = this.$store.getters.token
			this.getData()
        }
    },
    methods: {
        // 头条列表
        getData() {	
            var params = {
                page: this.pages.page,
				size: this.pages.size,
				type: 1 // 0后台发布1社区
			}
			if(this.token){
				params.token = this.token
			}
            if (this.push_type) {
                params.push_type = this.push_type
			}
			this.$api.toutiao.headlineList(params).then(res=>{
				if(res.code == 200){
					var list = res.result.list
					if(list.length != 0){
						for(var i in list){
							// 判断描述是否 多于60个字
							if(list[i].type == 0 && list[i].describe!= null && list[i].describe.length > 60){
								list[i].describe_hide = list[i].describe.slice(0,60) + '...'
								list[i].desc_hide = 1
							}
							// 多图
							if(list[i].images){
								list[i].imagesArr = list[i].images.split(',')
							}
							if(list[i].imagesArr && list[i].imagesArr.length > 3){
								var images = list[i].imagesArr
								list[i].images_hide = 1
								list[i].imagesSlice = images.slice(0,3)
							}
							this.dataList.push(list[i])
						}
						this.pages.page++
						this.loading = false	
					}else{
						this.finished = true
					}
				}else{
					this.finished = true
				}
				
			})
        },
		// 查看全部
		lookAllFun(item){
			for(var i in this.dataList){
				if(this.dataList[i].headline_id == item.headline_id){
					this.dataList[i].desc_hide = 0
					return
				}
			}
		},
		// 收起全部
		hideFun(item){
			for(var i in this.dataList){
				if(this.dataList[i].headline_id == item.headline_id){
					this.dataList[i].desc_hide = 1
					return
				}
			}
		},
        // 去详情
        goDetail: function (item) {
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					'data': {
					}
				}
				this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
					if (data.code == 200) {
						var name = '/toutiao/detail?headline_id='+item.headline_id
						var params = {
							'data': {
								'url': this.$publicData.clientUrl + name
							}
						}
						this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

						})
					} else {
						this.token = ''
					}
				})
				
            } else {
                this.$router.push({
					path: '/toutiao/detail',
					query: {
						headline_id: item.headline_id
					}
				})
            }
            
		},
		// 点赞
		clickLike(item){
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					'data': {
					}
				}
				this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
					if (data.code == 200) {
						this.token = data.result.token
						this.like(item)
					}
				})
				
            } else {
				this.like(item)
			}
		},
		like(item) {
			var is_like = item.is_like
			var params = {
				token: this.token,
				headline_id: item.headline_id
			}
			this.$api.toutiao.like(params).then(res=>{
				if(res.code == 200){
					for(var i in this.dataList){
						if(this.dataList[i].headline_id == item.headline_id){
							if(is_like == 0){
								this.dataList[i].is_like = 1
								this.dataList[i].num.like_num = parseInt(this.dataList[i].num.like_num) + 1
								this.$toast('点赞成功');
							}else if(is_like != 0){
								this.dataList[i].is_like = 0
								this.dataList[i].num.like_num = parseInt(this.dataList[i].num.like_num) - 1
								this.$toast('取消点赞成功');
							}
							return
						}
					}
				}
			})
		},
		// 点击收藏
		clickCollect(item){
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					'data': {
					}
				}
				this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
					if (data.code == 200) {
						this.token = data.result.token
						this.collect(item)
					}
				})
				
            } else {
				this.collect(item)
			}
		},
		collect(item) {
			var is_collect = item.is_collect
			var params = {
				token: this.token,
				headline_id: item.headline_id
			}
			this.$api.toutiao.collect(params).then(res=>{
				if(res.code == 200){
					for(var i in this.dataList){
						if(this.dataList[i].headline_id == item.headline_id){
							if(is_collect == 0){
								this.dataList[i].is_collect = 1
								this.dataList[i].num.collect_num = parseInt(this.dataList[i].num.collect_num) + 1
								this.$toast('收藏成功');
							}else if(is_collect != 0){
								this.dataList[i].is_collect = 0
								this.dataList[i].num.collect_num = parseInt(this.dataList[i].num.collect_num) - 1
								this.$toast('取消收藏成功');
							}
							return
						}
					}
				}
			})
		},
		// 展开大图
        zhanshitupian(item, arr, index) {
			for(let i in arr){
				arr[i] = this.imageUrl + arr[i];
			};
			if(index == 2 && item.images_hide){
				for( var i in this.dataList){
					if(this.dataList[i].headline_id == item.headline_id){
						this.dataList[i].images_hide = 0
						return
					}
				}
				return
			}
			this.bigTuImgArr = arr;
			this.bigTuIndex = index;
			this.bigTuShow = true;
        },
		// 切换大图
        bigTuChange(index) {
            this.bigTuIndex = index
        },
        // 发布头条
        toPublish: function () {
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					'data': {
					}
				}
				this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
					if (data.code == 200) {
						var name = '/toutiao/publish'
						var params = {
							'data': {
								'url': this.$publicData.clientUrl + name
							}
						}
						this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

						})
					} else {
						this.token = ''
					}
				})
				
            } else {
                if (!this.token) {
					localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
					this.$router.push({
						path: '/login',
					})
					return
				}
				this.$router.push({
					path: '/toutiao/publish'
				})
            }
        },

    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
